"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BufferLayout = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 */
class BufferLayout {
    constructor(buffers) {
        this.buffers = buffers;
    }
    getBufferCount() {
        return this.buffers.length;
    }
    getBuffers() {
        return this.buffers;
    }
    /**
     * Swaps the buffer at the index to the argument, returning the stored buffer.
     */
    swapBuffer(buffer, index) {
        DEBUG_MODE && rc_js_util_1._Debug.runBlock(() => {
            rc_js_util_1._Debug.assert(this.buffers.length > index, "index OOB");
            rc_js_util_1._Debug.assert(this.buffers[index] !== buffer, "attempted self swap");
        });
        const stored = this.buffers[index];
        this.buffers[index] = buffer;
        return stored;
    }
}
exports.BufferLayout = BufferLayout;
//# sourceMappingURL=buffer-layout.js.map